import { render } from "./SubThemeChart.vue?vue&type=template&id=0b23f7da&scoped=true"
import script from "./SubThemeChart.vue?vue&type=script&lang=js"
export * from "./SubThemeChart.vue?vue&type=script&lang=js"

import "./SubThemeChart.vue?vue&type=style&index=0&id=0b23f7da&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LMPELCHAT\\Documents\\vie-associative\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b23f7da"]])

export default __exports__